<template>
  <div v-if="viewVesselAccess">
    <div class="row" v-if="vessels.length > 0">
      <div class="col-md-4">
        <span>Наименование судна</span>
      </div>
      <div class="col-md-4">
        <span>Флаг судна</span>
      </div>
      <div :class="{'col-md-2 col-xs-9': canRemoveVessel, 'col-md-3': !canRemoveVessel}">
        <span>Причал</span>
      </div>
      <div class="col-md-1 col-xs-3" v-if="canRemoveVessel">
        <span></span>
      </div>
    </div>
    <div v-for="(vessel, vesselKey) in vessels" :key="vesselKey" class="row">
      <div class="col-md-4 mt-10">
        <vessel-input
          :form="form"
          :errors="errors"
          :disabled="disabledVessel"
          :vessel-id="vesselKey"
          v-model="vessel.name"
          @change="change('application vessel'); changeFlagByVesselName(vesselKey, vessel.name)"
        />
      </div>
      <div class="col-md-4 mt-10">
        <vessel-flag-input
          :form="form"
          :errors="errors"
          :items="availableNationalities"
          :disabled="disabledVesselFlag"
          :vessel-id="vesselKey"
          :pass-flag="vessel.passFlag"
          v-model="vessel.flag"
          @change="change('application vessel flag'); insertFlag(vessel.flag, vesselKey)"
        />
      </div>
      <div :class="{'col-md-3 col-xs-9': canRemoveVessel, 'col-md-4': !canRemoveVessel}" class="mt-10">
        <berth-input
          :form="form"
          :errors="errors"
          :items="sortedVesselBerthBook"
          :vessel-id="vesselKey"
          :disabled="disabledBerth"
          v-model="vessel.berth"
          @change="change('application berth')"
        />
    </div>
      <div class="col-md-1 col-xs-3" v-if="canRemoveVessel">
        <div class="form-group mt-10">
          <button
            type="button"
            style="display: block"
            :id="`btn-${{vesselKey}}`"
            class="btn btn-sm btn-default  form-control"
            @click="removeVessel(vesselKey)"
            title="Удалить"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import BerthInput from '@/common/components/application/form-inputs/pass/BerthInput'
import { Logger } from '@/common/helpers/Logger'
import mainMixin from '@/common/mixins/mainMixin'
import { TimeTypes } from '@/enums/TimeTypes'
import VesselFlagInput from '@/common/components/application/form-inputs/pass/VesselFlagInput'
import VesselInput from '@/common/components/application/form-inputs/pass/VesselInput'
import { VesselAccesses as VesselAccessesEnum } from '@/common/enums/VesselAccesses'

export default {
  name: 'VesselsFormBlock',
  mixins: [
    mainMixin,
    applicationFormMixin,
    applicationFormContextMixin
  ],

  components: {
    VesselInput,
    VesselFlagInput,
    BerthInput
  },

  model: {
    prop: 'change-vessels',
    event: 'change-vessels'
  },

  props: {
    vessels: {
      type: Array,
      required: true
    },

    application: {
      type: Object,
      required: true
    },

    vesselAccesses: {
      type: [Array, Object],
      default: () => []
    },

    personalNationalities: {
      type: [Array, Object],
      default: () => []
    },

    vesselBerthBook: {
      type: [Array, Object],
      default: () => []
    },

    regionVesselAccess: {
      type: Boolean
    },

    applicationPurpose: {
      type: [Array, Object]
    }
  },

  created () {
    if (this.vessels.length > 0 && (Number(this.applicationPurpose?.need_vessel) === 0 && !this.regionVesselAccess)) {
      this.application.vessel_access_id = VesselAccessesEnum.WITHOUT_VESSEL
      this.form.vessels = []
    }
    if (((this.isDuplicate && this.vessels.length === 0 && this.application.time_type === 'one') ||
        (this.isDraft && this.vessels.length === 0 && this.application.time_type === 'one')) && this.oneTimeTypeNeedVessel) {

      this.addVessel()
    }
    if (this.isDuplicate) {
      this.vessels.forEach(element => {
        let nationality = this.personalNationalities.find((item) => item.id === element.flag)
        if (Number(nationality.vessel_flag) === 0) {
          element.flag = null
          element.passFlag = null
        }
      })
    }
  },

  updated () {
    this.$nextTick(function () {
      this.defaultVessel()
    })
  },

  computed: {
    availableNationalities() {
      if (this.isVesselAccessWithoutResidency) {
        return this.personalNationalities
      }
      return this.isVesselAccessRus ? this.personalNationalities.filter((nationality) => nationality.id === 182)
        : this.personalNationalities.filter((nationality) => nationality.id !== 182);
    },

    isVesselAccessRus() {
      return Boolean((this.vesselAccesses.find((item) => item.id === this.form.application.vessel_access_id)).is_rf === 1)
    },

    isVesselAccessWithoutResidency() {
      return Boolean((this.vesselAccesses.find((item) => item.id === this.form.application.vessel_access_id)).is_rf === null)
    },

    sortedVesselBerthBook() {
      return this.vesselBerthBook.filter(vessel => Number(vessel.region_id) === Number(this.application.terminal_region_id))
    },

    disabledVessel () {
      return Boolean(
        this.disabledInput || this.application.vessel_access_id === VesselAccessesEnum.WITHOUT_VESSEL
      )
    },

    viewVesselAccess () {
      return Boolean(
        ((this.application.vessel_access_id !== VesselAccessesEnum.WITHOUT_VESSEL && this.regionVesselAccess)) ||
          (this.vessels.length > 0 && this.isView)
      )
    },

    disabledVesselFlag () {
      return Boolean(
        this.disabledInput ||
        !this.vessels ||
        this.application.vessel_access_id === VesselAccessesEnum.WITHOUT_VESSEL || this.isVesselAccessRus
      )
    },

    disabledBerth () {
      return Boolean(
        this.disabledInput ||
        !this.vessels ||
        this.application.vessel_access_id === VesselAccessesEnum.WITHOUT_VESSEL
      )
    },

    canRemoveVessel () {
      return Boolean((
        (this.form.vessels.length > 0 && [TimeTypes.PERMANENT, TimeTypes.TEMP].includes(this.form.application.time_type)) ||
          (this.form.vessels.length > 0 && this.form.application.time_type === TimeTypes.ONE &&
              Number(this.configuration.application_pass_type_one_can_be_without_vessel) === 1) ||
        (this.form.vessels.length > 1 && this.form.application.time_type === TimeTypes.ONE &&
            Number(this.configuration.application_pass_type_one_can_be_without_vessel) === 0)
      ) && !this.isView)
    },

    oneTimeTypeNeedVessel () {
      return Number(this.configuration.application_pass_type_one_can_be_without_vessel) === 0
    }
  },

  data: () => {
    return {
      baseUrl: process.env.BASE_URL
    }
  },

  methods: {
    change (inputName) {
      Logger.log(`Changed ${inputName}!`)
      this.$emit('change-vessels', this.vessels)
    },

    changeFlagByVesselName (vesselKey, vesselName) {
      const vessel = {
        id: vesselKey,
        name: vesselName
      }
      ApiClient.changeFlagByVesselName(vessel).then((response) => {
        const data = response.data.data
        if (data) {
          this.vessels[vesselKey].flag = data.flag
          this.insertFlag(this.vessels[vesselKey].flag, vesselKey)
        }
      })
    },

    defaultVessel () {
      const vessels = this.vessels
      const application = this.application

      if (vessels.length < 1 && application.time_type === 'one' && application.vessel_access_id && this.regionVesselAccess &&
          this.oneTimeTypeNeedVessel) {
        this.addVessel()
      }
    },

    removeVessel (vesselKey) {
      this.vessels.splice(vesselKey, 1)
    },

    addVessel () {
      let flag = this.isVesselAccessRus ? 182 : null
      let passFlag = this.isVesselAccessRus ? '/ru/terminal/vue/img/icons/countries/RU.svg' : null
      const vessel = Object.assign({}, {
        berth: null,
        flag: flag,
        name: null,
        passFlag: passFlag
      })
      this.vessels.push(vessel)
    },

    insertFlag (id, vesselKey) {
      const nationality = this.personalNationalities.find(currentValue => Number(currentValue.id) === Number(id))

      this.vessels[vesselKey].passFlag = nationality && nationality.iso2 && nationality.iso2 !== 'YU' ? this.baseUrl + 'img/icons/countries/' + nationality.iso2 + '.svg' : null
    }
  }
}
</script>
